module.exports = __webpack_public_path__ + "img/cat.03dc7a16.gif";